import { render, staticRenderFns } from "./Extension.vue?vue&type=template&id=2cfb5a49&scoped=true"
import script from "./Extension.vue?vue&type=script&lang=ts"
export * from "./Extension.vue?vue&type=script&lang=ts"
import style0 from "./Extension.vue?vue&type=style&index=0&id=2cfb5a49&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cfb5a49",
  null
  
)

export default component.exports